import './bootstrap';
import './components/layout/header';
import './components/layout/newLayout'

import { VhVariable } from './components/common/vhVariable';
import { FrequentQuestions } from './components/common/frequent-questions';
import HomePage from './components/home/home-page';
import ConfiguratorPage from './components/pricing/configurator-page';
import RegisterPage from './components/auth/register-page';
import AboutPage from './components/about/about-page';
import { NewKnowledgePageIndex } from './components/knowledge/new-knowledge-page-index'
import { NewKnowledgePageCategory } from './components/knowledge/new-knowledge-page-category';
import { NewKnowledgePageArticle } from './components/knowledge/new-knowledge-page-article'
import { NewKnowledgePageSearch } from './components/knowledge/new-knowledge-page-search';
import CookiesForPages from './components/cookies';
import ObserverForPages from "./components/observer";
import GoogleForPages from "./components/google-translate";
import { NewGoogleForPages } from './components/new-google-translate'
import { NewNewsPageIndex } from './components/news/new-news-page-index';
import { NewNewsPageSearch } from './components/news/new-news-page-search';
import { NewNewsPageCategory } from './components/news/new-news-page-category';
import { NewNewsPageArticle } from './components/news/new-news-page-article';
import { CustomAnchor } from './components/customAnchor';

new VhVariable;

// TODO: routing
switch (window.location.pathname) {
    case '/':
        new HomePage;
        new CookiesForPages;
        new ObserverForPages;
        new CustomAnchor;
        new NewGoogleForPages;
        break;

    case '/tariff':
        new CookiesForPages;
        new GoogleForPages;
        new FrequentQuestions;
        new NewGoogleForPages;
        break;/**/

    case '/configurator':
        new ConfiguratorPage;
        new CookiesForPages;
        new GoogleForPages;
        break;

    case '/register':
    case '/site/try-now':
    case '/try-now':
    case '/partner/':
    case '/login':
        new RegisterPage;
        new CookiesForPages;
        new ObserverForPages;
        new GoogleForPages;
        new NewGoogleForPages;
        break;

    case '/about':
        new AboutPage;
        new CookiesForPages;
        new ObserverForPages;
        new GoogleForPages;
        new NewGoogleForPages;
        break;

    case String(window.location.pathname.match(/^\/knowledge\/?$/gmi)):
        console.log('knowledge-index')
        new NewKnowledgePageIndex;
        new CookiesForPages;
        new ObserverForPages;
        new NewGoogleForPages;
        break;

    case String(window.location.pathname.match(/^\/knowledge\/search$/gmi)):
        console.log('knowledge-search')
        new NewKnowledgePageSearch;
        new CookiesForPages;
        new ObserverForPages;
        new NewGoogleForPages;
        break;

    case String(window.location.pathname.match(/^\/knowledge\/([^\/]+\/?){1}$/gmi)):
        console.log('knowledge-category')
        new NewKnowledgePageCategory;
        new CookiesForPages;
        new ObserverForPages;
        new NewGoogleForPages;
        break;
    case String(window.location.pathname.match(/^\/knowledge\/([^\/]+\/?){2}$/gmi)):
        console.log('knowledge-article')
        new NewKnowledgePageArticle;
        new CookiesForPages;
        new ObserverForPages;
        new NewGoogleForPages;
        break;

    case String(window.location.pathname.match(/^\/news\/?$/gmi)):
        console.log('news-index')
        new NewNewsPageIndex;
        new CookiesForPages;
        new ObserverForPages;
        new NewGoogleForPages;
        break;

    case String(window.location.pathname.match(/^\/news\/search$/gmi)):
        console.log('news-search')
        new NewNewsPageSearch;
        new CookiesForPages;
        new ObserverForPages;
        new NewGoogleForPages;
        break;

    case String(window.location.pathname.match(/^\/news\/([^\/]+\/?){1}$/gmi)):
        console.log('news-category')
        new NewNewsPageCategory;
        new CookiesForPages;
        new ObserverForPages;
        new NewGoogleForPages;
        break;
    case String(window.location.pathname.match(/^\/news\/([^\/]+\/?){2}$/gmi)):
        console.log('news-article')
        new NewNewsPageArticle;
        new CookiesForPages;
        new ObserverForPages;
        new NewGoogleForPages;
        break;
    case '/partner':
    case '/agreement':
    case '/personal':
    case '/legal':
        new CookiesForPages;
        new ObserverForPages;
        new GoogleForPages;
        break;

    default:
        console.log('default')
        new ObserverForPages;
        new CookiesForPages;
        new GoogleForPages;
}
